var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureLudwig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "253px",
    height: "21px",
    viewBox: "0 0 253 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ludwig-signature") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ludwig-signature",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fontFamily: "NanumPen, Nanum Pen",
    fontSize: 24,
    fontWeight: "normal",
    letterSpacing: -0.35
  }, /*#__PURE__*/React.createElement("text", {
    id: "Ludwig-Dumont,-Found",
    fill: "#2D2D2D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1,
    y: 17
  }, "Ludwig Dumont, Founder Willow")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureLudwig);
export default __webpack_public_path__ + "static/media/signature-ludwig.70b902dd4b4ece2bf018b367f2bd8370.svg";
export { ForwardRef as ReactComponent };